import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://rtsexpress.co.uk';

/**
 * SEO Component for dynamic meta tags
 * Used on all public pages for proper canonical URLs and meta descriptions
 */
export default function SEO({ 
  title = 'RTS EXPRESS LTD - Same Day Courier UK',
  description = "UK's trusted same-day courier service. Dedicated 3.5T van transport for businesses. Emergency delivery across England, Scotland & Wales. Get instant quotes.",
  path = '/',
  noIndex = false
}) {
  // Build canonical URL - always non-www HTTPS without query params
  const canonicalUrl = `${BASE_URL}${path}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
}
